import { apiFetch } from "./client";

export interface AgentSecret {
  id: string;
  agentId: string;
  envName: string;
  description: string | null;
  vaultSecretName: string;
  vaultScope: string;
  createdAt: string;
  updatedAt: string;
}

/**
 * Trimmed shape for tenant-wide pickers. Deliberately not an `AgentSecret`:
 * the server withholds the vault name and timestamps here, because a picker
 * only needs to show which credential is which.
 */
export interface CompanySecretOption {
  id: string;
  agentId: string;
  agentName: string;
  envName: string;
  description: string | null;
}

export const agentSecretsApi = {
  list: (agentId: string) =>
    apiFetch<AgentSecret[]>(`/agents/${agentId}/secrets`),

  /**
   * Every secret in the tenant, whichever agent owns it. Used by the workflow
   * canvas, where an HTTP action resolves its credential against any agent in
   * the company rather than one named agent.
   */
  listForCompany: (companyId: string) =>
    apiFetch<CompanySecretOption[]>(`/companies/${companyId}/secrets`),

  create: (agentId: string, data: { envName: string; value: string; description?: string; vaultScope?: string }) =>
    apiFetch<AgentSecret>(`/agents/${agentId}/secrets`, {
      method: "POST",
      body: JSON.stringify(data),
    }),

  remove: (agentId: string, secretId: string) =>
    apiFetch<void>(`/agents/${agentId}/secrets/${secretId}`, {
      method: "DELETE",
    }),

  sync: (agentId: string) =>
    apiFetch<{ success: boolean; secretCount: number; error?: string }>(`/agents/${agentId}/secrets/sync`, {
      method: "POST",
      body: JSON.stringify({}),
    }),
};
